import {IOpenOrderFilterSettings} from './ao-open-order-filter-settings.interface';

//#region DEFAULT _DEFAULT_AUTO_ORDER_OPEN_ORDER_FILTER_SETTINGS

export const _DEFAULT_AUTO_ORDER_OPEN_ORDER_FILTER_SETTINGS: Readonly<IOpenOrderFilterSettings> = {
  suggestionGreaterThanZero: false,
  orderQuantityGreaterThanZero: false,
  purchaseOrders: 'unset',
  selectedLineColors: [],
} as const;
//#endregion
